import React from 'react';
import filter from 'mn-utils/filter';
import upperFirst from 'mn-utils/upperFirst';
import virtualOutputComponentProvider
  from '../../../../../../utils/virtualOutputComponentProvider';
import {
  apiV2CryptoAccountsList,
} from '../../../../../../api/merchant/cryptoAccounts';
import Col from '../../../../../dumb/Col/C';
import MenuForItem from '../../../../../dumb/Menu/ForItem';
import Tooltip from '../../../../../dumb/Tooltip/B';
import {
  openPopupInfo,
} from '../../../../../../emitters/popup';
import {
  cryptoAccountId$
} from '../state';
import openPopupDeleteCryptoAccount from './openPopupDeleteCryptoAccount';


module.exports = virtualOutputComponentProvider({
  rowHeight: 114,
  request: apiV2CryptoAccountsList,
  requestWrapper(self, request, params) {
    // return self.props.disabled
    //   ? null
    //   : request(params);
    return request(params);
  },
  wrapper(render, setState, self) {
    function Item(props) {
      const {
        data,
      } = props;

      return (
        <div
          className={`w layoutRow fhaS fvaC h114 rlv lh fw7 f16 c2 tc lts0em
          ph20 (ph10|w1/4)>1 bgF6F6F6.even` + (props.index % 2 === 1 ? ' even' : '')}
        >
          <div>{data.network}</div>
          <div>
            <Tooltip>{data.address}</Tooltip>
          </div>
          <div>{data.coin}</div>
          <div>
            <div className={`cFFBF43.inactive c2CE889.active ` + data.status}>
              {upperFirst(data.status || '')}
            </div>
            <MenuForItem items={[
              {
                name: 'Edit',
                onClick() {
                  cryptoAccountId$.emit(data.id);
                },
              },
              {
                name: 'Delete',
                className: 'cE70F0F*2',
                onClick() {
                  if (data.primary) {
                    const msg = (<div>
                      <p>Company should have at least one bank account marked as &quot;Primary&quot;</p>
                      <p>Set/Add another bank account as &quot;primary&quot; and try again.</p>
                    </div>);
                    openPopupInfo(['Error', msg]);
                    return;
                  }
                  openPopupDeleteCryptoAccount(data, () => {
                    setState({
                      loading: false,
                      data: {
                        ...self.state.data,
                        list: filter(self.state.data.list, (v) => v.id !== data.id),
                      },
                    });
                  });
                },
              },
            ]}/>
          </div>
        </div>
      );
    }


    return (state, props) => {
      return (
        <div className={'mb-70 ov ovxA ' + (props.className || '')}>
          <div className="wmin600">
            <div className="bgE layoutRow fhaS fvaC r9 ov ph20 w1/4>1">
              <Col>Network</Col>
              <Col>Crypto Address</Col>
              <Col>Coin</Col>
              <Col>Status</Col>
            </div>
            <div className="hmin340 h100vh-510 ov c0>.CircularProgress">
              {render(Item)}
            </div>
          </div>
        </div>
      );
    };
  },
});
